/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderLightDto } from './ProviderLightDto';
import {
    ProviderLightDtoFromJSON,
    ProviderLightDtoFromJSONTyped,
    ProviderLightDtoToJSON,
    ProviderLightDtoToJSONTyped,
} from './ProviderLightDto';

/**
 * 
 * @export
 * @interface GetProvidersOfFiltersResponseDto
 */
export interface GetProvidersOfFiltersResponseDto {
    /**
     * Providers
     * @type {Array<ProviderLightDto>}
     * @memberof GetProvidersOfFiltersResponseDto
     */
    providers: Array<ProviderLightDto>;
}

/**
 * Check if a given object implements the GetProvidersOfFiltersResponseDto interface.
 */
export function instanceOfGetProvidersOfFiltersResponseDto(value: object): value is GetProvidersOfFiltersResponseDto {
    if (!('providers' in value) || value['providers'] === undefined) return false;
    return true;
}

export function GetProvidersOfFiltersResponseDtoFromJSON(json: any): GetProvidersOfFiltersResponseDto {
    return GetProvidersOfFiltersResponseDtoFromJSONTyped(json, false);
}

export function GetProvidersOfFiltersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProvidersOfFiltersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'providers': ((json['providers'] as Array<any>).map(ProviderLightDtoFromJSON)),
    };
}

export function GetProvidersOfFiltersResponseDtoToJSON(json: any): GetProvidersOfFiltersResponseDto {
    return GetProvidersOfFiltersResponseDtoToJSONTyped(json, false);
}

export function GetProvidersOfFiltersResponseDtoToJSONTyped(value?: GetProvidersOfFiltersResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'providers': ((value['providers'] as Array<any>).map(ProviderLightDtoToJSON)),
    };
}

